import { render, staticRenderFns } from "./BarnSensorsStrip.vue?vue&type=template&id=5dcad2e0&scoped=true&"
import script from "./BarnSensorsStrip.vue?vue&type=script&lang=js&"
export * from "./BarnSensorsStrip.vue?vue&type=script&lang=js&"
import style0 from "./BarnSensorsStrip.vue?vue&type=style&index=0&id=5dcad2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcad2e0",
  null
  
)

export default component.exports